/**
 * DSP验证类型枚举
 * 对应后端的验证场景
 */
export enum DspValidationType {
  /** 签收场景验证 */
  SIGN_RECEIPT = 'SIGN_RECEIPT',
  
  /** 异常上报场景验证 */
  EXCEPTION_REPORT = 'EXCEPTION_REPORT',
  
  /** POD修改场景验证 */
  POD_MODIFY = 'POD_MODIFY'
}
